import angular from 'angular';
import moment from 'moment';
import 'ui-select';
import 'ng-flow';
import './webPagesServices';
import '../webmodules/webModulesControllers';
import '../webmodules/webModulesServices';
import '../websections/webSectionsServices';
import locales from "@/scripts/locale";

const webPagesControllers = angular.module('applicationModule.webPagesControllers', [
    'applicationModule.webModulesControllers',
    'applicationModule.webPagesServices',
    'applicationModule.webSectionsServices',
    'flow',
    'ui.select'
]);

webPagesControllers.controller('WebpagesController', ['$scope', '$rootScope', '$stateParams', '$modal', '$state', 'growl', 'NgTableParams', 'AppsoupAPI', 'Webpages', 'Webmodules', 'WebSections', 'Permissions', '$timeout', function ($scope, $rootScope, $stateParams, $modal, $state, growl, NgTableParams, AppsoupAPI, Webpages, Webmodules, WebSections, Permissions, $timeout) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});
    const content = $('#content').offset();

    $('html, body').animate({scrollTop: content.top}, "slow");

    $scope.pageId = 0;
    $scope.pageLayout = false;
    $scope.layout = [];
    $scope.modules = [];
    $scope.check_module = [];
    $scope.search_module = [];
    $scope.isPublishing = false;
    $scope.isDropped = {};
    $scope.isDroppedPage = false;
    if (angular.isDefinedNotEmpty($stateParams.page_id)) {
        $scope.pageId = $stateParams.page_id;
        $scope.pageLayout = true;
    }
    $rootScope.$broadcast('wwwStructure', {app: $stateParams.application_id, limit: 10});

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    $scope.application_id = $stateParams.application_id;

    $scope.isCollapseModules = {};

    $scope.search = {};

    let modules = [];
    $scope.isLoading = true;
    Webpages.all($scope.application_id, $scope.pageId, $scope.pageLayout)
        .then(function (response) {
            if (response.success) {
                $scope.package_id = response.package_id;
                if ($scope.pageLayout) {
                    $scope.page = response.page;
                    response.layout.forEach(function (layout) {
                        $scope.isDropped[layout.key] = false;
                    });
                    $scope.layout = response.layout;
                    $scope.modules = response.modules;
                    modules = angular.copy(response.modules);
                    const sections = response.sections;

                    Object.keys(sections).forEach(function (key) {
                        sections[key] = sections[key].sort(function (a, b) {
                            return a.order > b.order;
                        });
                    });
                    $scope.sections = sections;
                    $scope.templates = response.templates;
                    $scope.view_templates = response.view_templates;
                    $scope.section_templates = response.section_templates;
                    $scope.module_names = response.module_names;
                    $scope.module_joining_ids = response.module_joining_ids;
                    $scope.client_url = response.client_url;
                    $scope.iframe_url = response.iframe_url;
                    $scope.links = response.links;
                    $scope.module_has_elements = response.module_has_elements;
                    $scope.module_template = response.module_template;
                    $scope.canPublish = response.publish;
                    $scope.package_id = response.package_id;
                }
            } else {
                $state.go('appsoup.application.webpages', {
                    application_id: $stateParams.application_id, page_id: null
                });
                growl.error(response.error);
            }
        })
        .finally(function () {
            $scope.isLoading = false;
        });

    $scope.tableParams = new NgTableParams(AppsoupAPI.getByOrderTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Webpages.getPages($scope.application_id, $scope.pageId, params._params).then(function (response) {
                params.total(response.data.total);
                params.count(response.data.per_page);
                params.page(response.data.current_page);

                return response.data.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        }, counts: AppsoupAPI.getMinDefaultstCounts()
    });

    $scope.searchPages = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
        $scope.check = true;

    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        $scope.check = false;
    };

    $scope.publish = function () {
        $scope.isPublishing = true;
        Webpages.publish($stateParams.application_id, $scope.pageId)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.PUBLISHED');
                    $state.go($state.current, {}, {reload: true});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.PUBLISHED');
                }
            })
            .finally(function () {
                $scope.isPublishing = false;
            });
    };

    $scope.savePageHistory = function () {
        Webpages.savePageHistory($stateParams.application_id, $scope.pageId)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.SAVED');
                    $state.go($state.current, {}, {reload: true});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.SAVED');
                }
            });
    };

    $scope.create = function () {
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, "slow");
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/pages/edit.tpl.html',
            controller: 'WebpageModalController',
            backdrop: 'static',
            resolve: {
                page: function () {
                    return {
                        parent: $scope.pageId
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            $rootScope.$broadcast('wwwStructure', {app: $stateParams.application_id, limit: 10});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.edit = function (pageId) {
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, "slow");

        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/pages/edit.tpl.html',
            controller: 'WebpageModalController',
            backdrop: 'static',
            resolve: {
                page: function () {
                    return {
                        id: pageId
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            $rootScope.$broadcast('wwwStructure', {app: $stateParams.application_id, limit: 10});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.copy = function (pageId) {
        Webpages.copy(pageId)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.COPIED');
                    $state.go($state.current, {}, {reload: true});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.COPIED');
                }
            });

    };

    $scope.removePage = function (id, index) {
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, "slow");
        Webpages.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                    $rootScope.$broadcast('wwwStructure', {app: $stateParams.application_id, limit: 10});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        let data = $scope.tableParams.data;
        $event.stopImmediatePropagation();
        Webpages.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            application_id: $scope.application_id,
            page_id: $scope.pageId
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse($scope.tableParams.data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };

    $scope.changeOrderExtreme = function ($event, key1, direction) {
        $event.stopImmediatePropagation();

        const data = $scope.tableParams.data;
        $scope.tableParams.data = angular.changeOrderExtreme(data, key1, direction);

        Webpages.changeOrderExtreme({
            data: data, application_id: $scope.application_id
        });
    };

    // drag&drop webpages
    $scope.treeOptionsPage = {
        accept: function (sourceNodeScope, destNodesScope) {
            const source = sourceNodeScope.$element.attr('data-parent');
            const dest = destNodesScope.$element.attr('data-parent');

            return source === dest;
        },

        beforeDrag: function () {
            return true;
        },

        dropped: function () {
            $scope.isDroppedPage = true;
            $timeout(function () {
                $scope.savePagesOrder($scope.tableParams.data);
            }, 700);
        }
    };

    $scope.savePagesOrder = function (data) {
        const tmpData = {
            application_id: $scope.application_id, page_id: $scope.pageId, data: data
        };

        Webpages.changePagesOrder(tmpData)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    // successful changed orders
                }
            })
            .finally(function () {
                $scope.isDroppedPage = false;
            });
    };

    $scope.sectionCreate = function (container) {
        $state.go('appsoup.application.webSectionNew', {
            application_id: $stateParams.application_id, page_id: $stateParams.page_id, container: container
        });
    };

    $scope.editSection = function (section, container) {
        $state.go('appsoup.application.webSectionEdit', {
            application_id: $stateParams.application_id,
            page_id: $stateParams.page_id,
            container: container,
            section_id: section.id
        });
    };

    $scope.copySection = function (section, container) {
        const data = angular.copy(section);
        data.application_id = $stateParams.application_id;
        data.page_id = $stateParams.page_id;
        data.container = container;
        data.name = data.name + ' - Kopia';
        WebSections.copy(data).then(function (result) {
            let data = result.data;
            if (data.success) {
                $state.go($state.current, {}, {reload: true});
                growl.success('MODULES.APPLICATIONS.MODULES.WWW.SECTION.SUCCESS.COPY');
            }
        });

    };

    $scope.removeSection = function (id, index, container) {
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, "slow");
        WebSections.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.SECTION.SUCCESS.DELETED');
                    $scope.sections[container].splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.SECTION.ERROR.DELETED');
                }
            });
    };

    $scope.module_create = function (container) {
        const content = $('#content').offset();
        $('html, body').animate({scrollTop: content.top}, "slow");
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/modules/edit.tpl.html',
            controller: 'WebModuleModalController',
            backdrop: 'static',
            size: 'xlg',
            resolve: {
                module: function () {
                    return {
                        page_id: $scope.pageId, container: container
                    };
                }, params: function () {
                    return {
                        page_id: $scope.pageId, container: container
                    };
                }
            }
        });
        modalInstance.result.then(function (data) {
            if (data && data.module && data.module.id) {
                const module = data.module;
                module.joining_id = module.joining_id || module.id;
                $scope.modules[container].push(module);
            } else {
                $state.go($state.current, {}, {reload: true});
            }
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.MODULES.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.edit_module = function (module, container, $event) {
        //const content = $('#content').offset();
        //$('html, body').animate({scrollTop: content.top}, "slow");

        if (angular.isNullOrUndefined(module.joining_id)) {
            const moduleId = module;
            module = {};
            module.joining_id = moduleId;
        }
        $event.stopImmediatePropagation();
        Webmodules.get(module.joining_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    data.module.container = container;
                    const modalInstance = $modal.open({
                        templateUrl: 'views/application/web/modules/edit.tpl.html',
                        controller: 'WebModuleModalController',
                        backdrop: 'static',
                        size: 'xlg',
                        resolve: {
                            module: function () {
                                return data.module;
                            }, params: function () {
                                return {
                                    page_id: $scope.pageId, container: data.module.container
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (data && data.module && data.module.id) {
                            const index = $scope.modules[container].findIndex(function (el) {
                                return el.id === data.module.id;
                            });
                            if (index >= 0) {
                                $scope.modules[container][index] = angular.extend($scope.modules[container][index], data.module);
                            }
                            if ($scope.module_names[data.module.id]) {
                                $scope.module_names[data.module.id] = data.module.name;
                            }
                        } else {
                            $state.go($state.current, {}, {reload: true});
                        }
                        growl.success('MODULES.APPLICATIONS.MODULES.WWW.MODULES.SUCCESS.EDITED');
                    }).catch(() => {});
                }
            });
    };

    $scope.scrollTo = function (layoutSelector) {
        const id = '#www-' + layoutSelector;
        const content = $(id).offset();
        $('html, body').animate({scrollTop: content.top}, "slow");
    };

    $scope.remove_module = function (pageModuleId, moduleId, index, container) {
        const content = $('#content').offset();

        $('html, body').animate({scrollTop: content.top}, "slow");
        const indexToRemove = $scope.modules[container].findIndex(function (module) {
            return module.id === moduleId;
        });

        Webmodules.remove(pageModuleId, $scope.application_id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.MODULES.SUCCESS.DELETED');
                    $scope.modules[container].splice(indexToRemove, 1);
                    removeModulesFromSectionsList(moduleId);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.MODULES.ERROR.DELETED');
                }
            });
    };

    $scope.module_changeOrder = function ($event, key1, key2, container) {
        $event.stopImmediatePropagation();
        Webmodules.changeOrder({
            order_ids: [$scope.modules[container][key1].order, $scope.modules[container][key2].order],
            application_id: $scope.application_id,
            page_id: $scope.pageId
        })
            .then(function (response) {
                if (response.data.success) {
                    const tmp_order = $scope.modules[container][key1].order;
                    $scope.modules[container][key1].order = $scope.modules[container][key2].order;
                    $scope.modules[container][key2].order = tmp_order;

                    const tmp = angular.copy($scope.modules[container][key1]);
                    $scope.modules[container][key1] = angular.copy($scope.modules[container][key2]);
                    $scope.modules[container][key2] = tmp;
                }
            });
    };

    $scope.section_changeOrder = function ($event, key1, key2, container) {
        $event.stopImmediatePropagation();
        WebSections.changeOrder({
            order_ids: [$scope.sections[container][key1].order, $scope.sections[container][key2].order],
            application_id: $scope.application_id,
            page_id: $scope.pageId
        })
            .then(function (response) {
                if (response.data.success) {
                    const tmp_order = $scope.sections[container][key1].order;
                    $scope.sections[container][key1].order = $scope.sections[container][key2].order;
                    $scope.sections[container][key2].order = tmp_order;

                    const tmp = angular.copy($scope.sections[container][key1]);
                    $scope.sections[container][key1] = angular.copy($scope.sections[container][key2]);
                    $scope.sections[container][key2] = tmp;
                }
            });
    };

    $scope.section_changeOrderExtreme = function ($event, key1, container, direction) {
        $event.stopImmediatePropagation();

        const data = $scope.sections[container];
        $scope.sections[container] = angular.changeOrderExtreme(data, key1, direction);

        WebSections.changeOrderExtreme({
            data: data, application_id: $scope.application_id
        });
    };

    // drag&drop websections
    $scope.treeOptionsSection = {
        accept: function (sourceNodeScope, destNodesScope) {
            const source = sourceNodeScope.$element.attr('data-parent');
            const dest = destNodesScope.$element.attr('data-parent');

            return source === dest;
        },

        beforeDrag: function () {
            return true;
        },

        dropped: function (event) {
            const source = event.source.nodeScope.$element.attr('data-parent');
            $scope.isDropped[source] = true;
            $timeout(function () {
                $scope.saveSectionsOrder(source);
            }, 700);
        }
    };

    $scope.saveSectionsOrder = function (source) {
        const tmpData = {
            application_id: $scope.application_id, page_id: $scope.pageId, data: $scope.sections[source]
        };

        WebSections.changeSectionsOrder(tmpData)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    // successful changed orders
                }
            })
            .finally(function () {
                $scope.isDropped[source] = false;
            });
    };

    $scope.searchModule = function (search_module, container) {
        $scope.isFind = true;
        const find = angular.copy(search_module);
        $scope.modules[container] = [];
        $scope.isCollapseModules[container] = true;
        angular.forEach(modules[container], function (val) {
            const pageName = val.name.toLowerCase();
            if (pageName.indexOf(find.name.toLowerCase()) !== -1) {
                $scope.modules[container].push(val);
            }
        });
        if (find.name !== '') {
            $scope.check_module[container] = true;
        }
        $scope.isFind = false;
    };

    $scope.clearSearchModule = function (container) {
        $scope.search_module[container] = {};
        $scope.check_module[container] = false;
        $scope.modules[container] = angular.copy(modules[container]);
    };

    $scope.publicAll = function (appId) {
        $scope.isLoadingPublish = true;
        Webpages.publicAll(appId)
            .then(function (response) {
                if (response.data.success) {
                    growl.success('Opublikowano wszystkie strony');
                }
            }).finally(function () {
            $scope.isLoadingPublish = false;
        });
    };

    $scope.export = function (pageId, moduleId) {
        $scope.isLoadingExport = true;
        Webpages.export($scope.application_id, pageId, moduleId)
            .then(function (result) {
                let data = result.data;
                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
            }).finally(function () {
            $scope.isLoadingExport = false;
        });
    };

    $scope.updateProducerPages = function (appId, producerPages) {
        Webpages.updateProducerPages($scope.application_id, producerPages)
            .then(function (result) {
                let data = result.data;
                if (angular.isDefined(data.success)) {
                    growl.success('Zaktualizowano strony');
                    growl.success('Strony: ' + data.pages);
                } else {
                    growl.error(data.error);
                }
            });
    };

    const removeModulesFromSectionsList = function (id) {
        angular.forEach(Object.keys($scope.sections), function (container) {
            angular.forEach($scope.sections[container], function (section) {
                angular.forEach(Object.keys(section.modules), function (key) {
                    if (section.modules[key] === id) {
                        delete section.modules[key];
                    }
                });
            });
        });
    };
}]);

webPagesControllers.controller('WebpageModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'page', '$filter', '$translate', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, page, $filter, $translate) {
    'use strict';

    const appId = $stateParams.application_id;
    const noParentKey = 0;
    $scope.page = {};
    $scope.pages = [];
    $scope.languages = {};
    $scope.editMode = false;
    $scope.package_id = null;
    $scope.upload = undefined;
    $scope.uploadNip = undefined;
    $scope.uploadUserGroups = undefined;
    $scope.fileUploaded = false;
    $scope.fileUploadedNip = false;
    $scope.fileUploadedUserGroups = false;
    $scope.fileName = undefined;
    $scope.invalidContractor = undefined;
    $scope.invalidUserGroups = undefined;
    if (angular.isDefined(page.parent)) {
        $scope.page.parent = parseInt(page.parent);
    }
    $scope.page.template = 'default';
    $scope.page.active = 1;
    $scope.page.language = 'pl';

    if (page.id) {
        $scope.editMode = true;
        Webpages.get(page.id, appId)
            .then(function (response) {
                if (response.data.success) {
                    $scope.page = response.data.page;
                    $scope.package_id = response.data.package_id;
                    if ($scope.page['contractors'][0]) {
                        $scope.fileName = $scope.page['contractors'][0];
                        $scope.fileUploaded = true;
                    }
                    if ($scope.page['nips'][0]) {
                        $scope.fileName = $scope.page['nips'][0];
                        $scope.fileUploaded = true;
                    }
                    if ($scope.page['user_groups']) {
                        $scope.fileNameUserGroups = $scope.page['user_groups'];
                        $scope.fileUploadedUserGroups = true;
                    }
                }
            });

    }

    Webpages.create(appId, $scope.editMode, page.id)
        .then(function (response) {
            if (response.data.success) {
                $scope.templates = response.data.templates.www_select;
                $scope.departments = response.data.departments;
                $scope.macroregions = response.data.macroregions;
                $scope.languages = response.data.languages;
                $scope.pages = response.data.pages;
                $scope.pages.unshift({
                    key: noParentKey, value: $translate.instant('MODULES.APPLICATIONS.MODULES.WWW.PAGES.NO_PARENT')
                });
            }
        });

    $scope.generateLink = function () {
        if ($scope.page.name) {
            const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
            const str = angular.copy($scope.page.name);
            str = str.replace(/\s+/g, '-').toLowerCase();
            str = str.replace(/[^\w ]/g, function (char) {
                return dict[char] || char;
            });
            str = str.replace(/[^0-9a-z-]+/g, '');
            str = str.replace(/[-]+/g, '-');
            $scope.page.link = str;
        }
    };

    $scope.$watch('page.link', function (oldValue, newValue) {
        if ($scope.page.link) {
            if (oldValue !== newValue) {
                const dict = {
                    'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'
                };
                const str = angular.copy($scope.page.link);
                str = str.replace(/\s+/g, '-').toLowerCase();
                str = str.replace(/[^\w ]/g, function (char) {
                    return dict[char] || char;
                });
                str = str.replace(/[^/0-9a-z-]+/g, '');
                str = str.replace(/[-]+/g, '-');
                $scope.page.link = str;
            }
        }
    });

    $scope.autocomplete = function (text) {
        text = $filter('removeSpecial')(text);

        if (angular.isDefined(text)) {
            Webpages.tags(appId, text).then(function (result) {
                let data = result.data;
                if (data.success) {
                    $scope.tags = data.tags;
                }
            });
        }
    };

    $scope.tags = [];

    $scope.changeTags = function () {
        if (angular.isDefined($scope.page.tags)) {
            const tempTags = [];
            angular.forEach($scope.page.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.page.tags = tempTags;
        }
    };

    $scope.ok = function () {
        $scope.pageForm.link.$invalid = false;
        $scope.$broadcast('show-errors-check-validity');
        $scope.page.application_id = appId;
        $scope.isLoading = true;

        if (angular.isDefined($scope.page.tags)) {
            const tags = [];

            angular.forEach($scope.page.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value)) {
                    tags.push(value);
                }
            });

            $scope.page.tags = tags;
        }

        Webpages.save($scope.page, $scope.upload, $scope.uploadNip, $scope.uploadUserGroups, $scope.editMode, $scope.fileUploaded)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.page);
                } else {
                    if (typeof data.error === 'object') {
                        if (data.error.contractors) {
                            $scope.invalidContractor = 'ERROR.' + data.error.contractors;

                            $translate($scope.invalidContractor).then(function () {
                            }, function () {
                                $scope.invalidContractor = 'ERROR.CONTRACTOR.UPLOAD_FILE_FAILED';
                            });
                        }
                        if (data.error.user_groups) {
                            $scope.invalidUserGroups = 'Błędnie zaimportowany plik!';
                        }
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.invalidContractor = undefined;
        $scope.fileUploaded = false;
        $scope.invalidUpload = false;
        $scope.fileName = undefined;

        $scope.uploadNip = undefined;
        $scope.fileUploadedNip = false;
        $scope.invalidUploadNip = false;

        $scope.page['contractors'] = [];
    };
    $scope.removeFileUserGroups = function () {
        $scope.uploadUserGroups = undefined;
        $scope.invalidUserGroups = undefined;
        $scope.fileUploadedUserGroups = false;
        $scope.fileNamUserGroupse = undefined;
        $scope.page['user_groups'] = null;
    };
    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileName = undefined;
        $scope.invalidUpload = false;
        $scope.$apply();
    };
    $scope.uploadSuccessUserGroups = function (file) {
        $scope.uploadUserGroups = file;
        $scope.fileUploadedUserGroups = true;
        $scope.fileNameUserGroups = undefined;
        $scope.invalidUserGroups = false;
        $scope.$apply();
    };
    $scope.uploadSuccessNip = function (file) {
        $scope.uploadNip = file;
        $scope.fileUploadedNip = true;
        $scope.invalidUploadNip = false;
        $scope.$apply();
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'link': [{error: 'required', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.LINK'}],
        'name': [{error: 'required', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'}],
        'metatags': [{error: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.METATAGS'}]
    };

    $scope.$watch('page.only_logged_in', function () {
        if ($scope.page.only_logged_in) {
            $scope.removeFile();
        }
    });
}]);

webPagesControllers.controller('WebpagePreviewController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', function ($state, $scope, $rootScope, $stateParams, growl, Webpages) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.json = {};
    Webpages.preview($stateParams.application_id, $stateParams.page_id, $stateParams.type)
        .then(function (result) {
            $scope.json = result.data;
        });
}]);

webPagesControllers.controller('WebpageHistoryController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, Webpages, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

    const appId = $stateParams.application_id;
    const pageId = $stateParams.page_id;

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    Webpages.getHistory(appId, pageId)
        .then(function (result) {
            let data = result.data;
            $scope.pages = data.pages;
        });

    $scope.removePage = function (id, index) {
        Webpages.deleteHistory(appId, id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.DELETED');
                    $scope.pages.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.DELETED');
                }
            });
    };

    $scope.restorePage = function (id) {
        Webpages.restoreHistory(appId, id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.RESTORED');
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.RESTORED');
                }
            });
    };
}]);

webPagesControllers.controller('WebpageVersionsController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', '$modal', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, Webpages, $modal, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

    const appId = $stateParams.application_id;
    const pageId = $stateParams.page_id;

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    Webpages.getVersions(appId, pageId)
        .then(function (result) {
            let data = result.data;
            $scope.versions = data.versions;
        });

    $scope.removeVersion = function (id, index) {
        Webpages.deleteVersion(appId, id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.VERSION.DELETED');
                    $scope.versions.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.VERSION.DELETED');
                }
            });
    };

    $scope.editVersion = function (version) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/version.tpl.html',
            controller: 'WebpageVersionModalController',
            backdrop: 'static',
            resolve: {
                version: function () {
                    return version;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.VERSION.EDITED');
        }).catch(() => {});
    };

    $scope.versionCreate = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/version.tpl.html',
            controller: 'WebpageVersionModalController',
            backdrop: 'static',
            resolve: {
                version: function () {
                    return {
                        page_id: pageId, application_id: appId
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.VERSION.CREATED');
        }).catch(() => {});
    };
}]);

webPagesControllers.controller('WebpageVersionModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'version', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, version) {
    'use strict';

    $scope.version = {};
    $scope.version = angular.copy(version);
    $scope.editMode = false;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.fileName = undefined;
    $scope.uploadImage = undefined;
    $scope.fileUploadedImage = false;
    $scope.invalidContractor = undefined;

    if (version.class) {
        $scope.editMode = true;
        $scope.version = angular.copy(version);
        if (angular.isDefinedNotNull($scope.version.image)) {
            $scope.fileUploadedImage = true;
        }
        if (angular.isDefined($scope.version.contractors) && $scope.version.contractors[0]) {
            $scope.fileName = $scope.version.contractors[0];
            $scope.fileUploaded = true;
        }
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Webpages.saveVersion($scope.version, $scope.upload, $scope.uploadImage, $scope.editMode)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.version);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                        if (data.error.contractors) {
                            $scope.invalidContractor = data.error.contractors === 'Undefined index: file' ? 'CONTRACTOR.UNDEFINED_INDEX' : 'CONTRACTOR.INVALID_COLUMNS';
                        }
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.VERSION.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.invalidContractor = undefined;
        $scope.version.contractors = [];
        $scope.fileUploaded = false;
        $scope.fileName = undefined;
    };

    $scope.removeFileImage = function () {
        $scope.uploadImage = undefined;
        $scope.fileUploadedImage = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.fileName = undefined;
        $scope.$apply();
    };

    $scope.uploadSuccessImage = function (file) {
        $scope.uploadImage = file;
        $scope.fileUploadedImage = true;
        $scope.$apply();
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'class': [{error: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'}]
    };
}]);

webPagesControllers.controller('WebpageHeadersController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'NgTableParams', 'AppsoupAPI', 'Webpages', '$modal', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, NgTableParams, AppsoupAPI, Webpages, $modal, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

    const appId = $stateParams.application_id;

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    $scope.search = {
        name: ''
    };
    $scope.isFind = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return Webpages.getAllHeaders(appId, params._params)
                .then(function (response) {
                    params.total(response.headers.total);
                    params.count(response.headers.per_page);
                    params.page(response.headers.current_page);

                    $scope.headersValues = response.headers_values;

                    return response.headers.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }, counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeHeader = function (id, index) {
        Webpages.deleteHeader(appId, id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.HEADER.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.HEADER.DELETED');
                }
            });
    };

    $scope.editHeader = function (header) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/header.tpl.html',
            controller: 'WebpageHeaderModalController',
            backdrop: 'static',
            resolve: {
                header: function () {
                    return header;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.HEADER.EDITED');
        }).catch(() => {});
    };

    $scope.headerCreate = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/header.tpl.html',
            controller: 'WebpageHeaderModalController',
            backdrop: 'static',
            resolve: {
                header: function () {
                    return {
                        application_id: appId
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.HEADER.CREATED');
        }).catch(() => {});
    };

    $scope.copyHeader = function (data) {
        const header = angular.copy(data);
        delete header.id;
        header.name = header.name + ' - Kopia';
        header.page_ids = [];
        Webpages.saveHeader(header, false)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.HEADER.CREATED');
                    $state.go($state.current, {}, {reload: true});
                }
            });
    };

    $scope.editElements = function (header) {
        $state.go('appsoup.application.webpagesHeadersElements', {appId: appId, headerId: header.id});
    };

    $scope.searchHeaders = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
}]);

webPagesControllers.controller('WebpageHeaderModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'header', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, header) {
    const appId = $stateParams.application_id;
    $scope.header = {
        page_ids: [], application_id: appId
    };
    $scope.editMode = false;

    if (header.name) {
        $scope.editMode = true;
        $scope.header = angular.copy(header);
    }

    Webpages.createHeader(appId, $scope.editMode)
        .then(function (response) {
            if (response.data.success) {
                $scope.templates = response.data.templates;
            }
        });

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        Webpages.autocompletePages(appId, text).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.pages = data.pages;
            }
        });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Webpages.saveHeader($scope.header, $scope.editMode)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.header);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.HEADER.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'class': [{error: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'}]
    };
}]);

webPagesControllers.controller('WebpageFootersController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'NgTableParams', 'AppsoupAPI', 'Webpages', '$modal', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, NgTableParams, AppsoupAPI, Webpages, $modal, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

    const appId = $stateParams.application_id;

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    $scope.search = {
        name: ''
    };
    $scope.isFind = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Webpages.getAllFooters(appId, params._params)
                .then(function (response) {
                    params.total(response.footers.total);
                    params.count(response.footers.per_page);
                    params.page(response.footers.current_page);
                    $scope.footersValues = response.footers_values;

                    return response.footers.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }, counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeFooter = function (id, index) {
        Webpages.deleteFooter(appId, id)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.FOOTER.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.FOOTER.DELETED');
                }
            });
    };

    $scope.editFooter = function (footer) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/footer.tpl.html',
            controller: 'WebpageFooterModalController',
            backdrop: 'static',
            resolve: {
                footer: function () {
                    return footer;
                }
            }
        });

        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.FOOTER.EDITED');
        }).catch(function (reason) {});
    };

    $scope.footerCreate = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/footer.tpl.html',
            controller: 'WebpageFooterModalController',
            backdrop: 'static',
            resolve: {
                footer: function () {
                    return {
                        application_id: appId
                    };
                }
            }
        });

        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.FOOTER.CREATED');
        }).catch(function (reason) {});
    };

    $scope.editElements = function (footer) {
        $state.go('appsoup.application.webpagesFootersElements', {appId: appId, footerId: footer.id});
    };

    $scope.searchFooters = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
}]);

webPagesControllers.controller('WebpageFooterModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'footer', '$filter', '$locale', '$modal', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, footer, $filter, $locale, $modal) {
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    const appId = $stateParams.application_id;
    $scope.footer = {
        page_ids: [], application_id: appId
    };
    $scope.editMode = false;

    if (footer.name) {
        $scope.editMode = true;
        $scope.footer = angular.copy(footer);
    }

    Webpages.createFooter(appId, $scope.editMode)
        .then(function (response) {
            if (response.data.success) {
                $scope.templates = response.data.templates;
                $scope.inputs = response.data.inputs;
            }
        });

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        Webpages.autocompletePages(appId, text).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.pages = data.pages;
            }
        });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        angular.forEach($scope.footer.modules, function (value, key) {
            if (value.draft) {
                value.draft = Object.assign({}, value.draft);
            } else {
                value.draft = {};
            }

            $scope.footer.modules[key] = value;
        });

        Webpages.saveFooter($scope.footer, $scope.editMode)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.footer);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.FOOTER.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'class': [{error: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'}]
    };
}]);

webPagesControllers.controller('WebpageSidebarsController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'NgTableParams', 'AppsoupAPI', 'Webpages', '$modal', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, NgTableParams, AppsoupAPI, Webpages, $modal, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});

    const appId = $stateParams.application_id;

    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    $scope.isLoading = true;

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    $scope.search = {
        name: ''
    };
    $scope.isFind = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Webpages.getAllSidebars(appId, params._params)
                .then(function (response) {
                    params.total(response.sidebars.total);
                    params.count(response.sidebars.per_page);
                    params.page(response.sidebars.current_page);

                    $scope.sidebarsValues = response.sidebars_values;
                    return response.sidebars.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }, counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeSidebar = function (id, index) {
        Webpages.deleteSidebar(appId, id).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.SIDEBAR.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.SIDEBAR.DELETED');
            }
        });
    };

    $scope.editSidebar = function (sidebar) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/sidebar.tpl.html',
            controller: 'WebpageSidebarModalController',
            backdrop: 'static',
            resolve: {
                sidebar: function () {
                    return sidebar;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.SIDEBAR.EDITED');
        }).catch(() => {});
    };

    $scope.sidebarCreate = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/sidebar.tpl.html',
            controller: 'WebpageSidebarModalController',
            backdrop: 'static',
            resolve: {
                sidebar: function () {
                    return {
                        application_id: appId
                    };
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.SIDEBAR.CREATED');
        }).catch(() => {});
    };

    $scope.searchSidebars = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };

    $scope.editElements = function (sidebar) {
        $state.go('appsoup.application.webpagesSidebarsElements', {appId: appId, sidebarId: sidebar.id});
    };
}]);

webPagesControllers.controller('WebpageSidebarModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'sidebar', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, sidebar) {
    'use strict';

    const appId = $stateParams.application_id;

    $scope.sidebar = {
        page_ids: [], app_id: appId
    };
    $scope.editMode = false;
    $scope.isLoading = true;

    if (sidebar.name) {
        $scope.editMode = true;
        $scope.sidebar = angular.copy(sidebar);
    }

    Webpages.createSidebar(appId, $scope.editMode).then(function (result) {
        let data = result.data;
        if (data.success) {
            $scope.templates = data.templates;
        }
    }).finally(function () {
        $scope.isLoading = false;
    });

    $scope.autocomplete = function (text) {
        text = text.toLowerCase().trim();
        text = encodeURIComponent(text);

        Webpages.autocompletePages(appId, text).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.pages = data.pages;
            }
        });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.sidebarForm.$valid) {
            $scope.isLoading = true;
            Webpages.saveSidebar($scope.sidebar, $scope.editMode).then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.sidebar);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.SIDEBAR.CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'class': [{error: '$invalid', msg: 'MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.REQUIRE.NAME'}]
    };
}]);

webPagesControllers.controller('WebpageHeadersElementsController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', '$modal', 'Permissions', '$timeout', function ($state, $scope, $rootScope, $stateParams, growl, Webpages, $modal, Permissions, $timeout) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');
    $scope.isDropped = false;

    const appId = $stateParams.application_id;
    const headerId = $stateParams.headerId;

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    Webpages.getHeader(appId, headerId)
        .then(function (result) {
            let data = result.data;
            $scope.header = data.header;
            $scope.inputs = data.inputs;
        });

    $scope.elementCreate = function (header, input, moduleKey) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/headerElement.tpl.html',
            controller: 'WebpageHeaderElementModalController',
            backdrop: 'static',
            resolve: {
                header: function () {
                    return header;
                }, input: function () {
                    return input;
                }, element: function () {
                    return {};
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editElement = function (header, input, moduleKey, element) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/headerElement.tpl.html',
            controller: 'WebpageHeaderElementModalController',
            backdrop: 'static',
            resolve: {
                header: function () {
                    return header;
                }, input: function () {
                    return input;
                }, element: function () {
                    return element;
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.EDITED');
        }).catch(() => {});
    };
    $scope.removeElement = function (id, index, key) {
        Webpages.removeHeaderElement(id, headerId, key)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.ELEMENT.DELETED');
                    $state.go($state.current, {}, {reload: true});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.ELEMENT.DELETED');
                }
            });
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.changeOrder = function ($event, key1, key2, moduleKey) {
        const data = $scope.header.modules[moduleKey].elements;
        $event.stopImmediatePropagation();
        Webpages.changeOrderHeaders({
            order_ids: [$scope.header.modules[moduleKey].elements[key1].order, $scope.header.modules[moduleKey].elements[key2].order],
            application_id: appId,
            module_key: moduleKey,
            header_id: headerId
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.header.modules[moduleKey].elements = data;
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.webpagesHeaders', {appId: appId});
    };

    // drag&drop
    $scope.treeOptions = {
        beforeDrag: function () {
            return true;
        }, dropped: function () {
            $scope.isDropped = true;
            $timeout(function () {
                $scope.saveOrder($scope.header.modules);
            }, 1000);
        }
    };

    $scope.saveOrder = function (data) {
        const tmpData = {
            application_id: appId, header_id: headerId, modules: data
        };

        Webpages.changeOrderHeaders(tmpData)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    // successful changed orders
                }
            })
            .finally(function () {
                $scope.isDropped = false;
            });
    };
}]);

webPagesControllers.controller('WebpageHeaderElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'header', 'input', 'element', 'module', 'Webmodules', '$locale', '$filter', '$modal', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, header, input, element, module, Webmodules, $locale, $filter, $modal) {
    'use strict';

    const headerId = $stateParams.headerId;
    $scope.elem = {};

    $scope.errors = {};
    $scope.upload = {};
    $scope.fileUploaded = {};
    $scope.fileName = {};

    if (element.id) {
        $scope.editMode = true;
        $scope.elem = angular.copy(element);
    }

    $scope.header = angular.copy(header);
    $scope.inputs = angular.copy(input);
    $scope.moduleKey = angular.copy(module);
    $scope.templates = [];
    $scope.moduleInputs = [];
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    angular.forEach($scope.inputs, function (val) {
        if (val.type === 'checkbox') {
            if (angular.isDefined($scope.elem[val.key])) {
                if ($scope.elem[val.key] == 'true') {
                    $scope.elem[val.key] = true;
                }
                if ($scope.elem[val.key] == 'false') {
                    $scope.elem[val.key] = false;
                }
            }
        }
        if (val.pattern) {
            val.pattern = new RegExp('^' + val.pattern + '$');
        }
    });

    $scope.pages = [];
    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        Webpages.autocompleteHeaders(headerId, $scope.moduleKey, text)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $scope.pages = data.elements;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.' + data.error);
                }
            });
    };

    Webmodules.getTemplates()
        .then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.templates = data.templates;
            }
        });

    $scope.change_template = function (template) {
        $scope.moduleInputs = [];
        $scope.isLoading2 = true;

        Webmodules.getTemplateInputs(template)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $scope.moduleInputs = data.inputs;
                }
            })
            .finally(function () {
                $scope.isLoading2 = false;
            });
    };

    if ($scope.elem.template) {
        $scope.change_template($scope.elem.template);
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.elementForm.$valid) {
            $scope.isLoading = true;
            $scope.elem.header_id = headerId;
            $scope.elem.module_key = $scope.moduleKey;
            Webpages.saveElementHeader($scope.elem, $scope.upload, $scope.editMode)
                .then(function (result) {
                    let data = result.data;
                    if (data.success) {
                        $modalInstance.close(data.element);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        } else {
            growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.checkValid = function (name) {
        return angular.isDefinedNotNull($scope.errors[name]);
    };

    $scope.removeFile = function (key) {
        delete $scope.upload[key];
        if (angular.isDefined($scope.elem[key])) {
            delete $scope.elem[key];
        }
        $scope.fileUploaded[key] = false;
        $scope.fileName[key] = undefined;
    };

    $scope.uploadSuccess = function (file, key) {
        $scope.upload[key] = file;
        $scope.fileUploaded[key] = true;
        $scope.fileName[key] = undefined;
        $scope.$apply();
    };
}]);

webPagesControllers.controller('WebpageFootersElementsController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', '$modal', 'Permissions', function ($state, $scope, $rootScope, $stateParams, growl, Webpages, $modal, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');

    const appId = $stateParams.application_id;
    const footerId = $stateParams.footerId;

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");

    $scope.isLoading = true;

    Webpages.getFooter(appId, footerId)
        .then(function (result) {
            let data = result.data;
            $scope.footer = data.footer;
            $scope.inputs = data.inputs;
        })
        .finally(function () {
            $scope.isLoading = false;
        });

    $scope.elementCreate = function (footer, input, moduleKey) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/footerElement.tpl.html',
            controller: 'WebpageFooterElementModalController',
            backdrop: 'static',
            resolve: {
                footer: function () {
                    return footer;
                }, input: function () {
                    return input;
                }, element: function () {
                    return {};
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.CREATED');
        });
    };

    $scope.editElement = function (footer, input, moduleKey, element) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/footerElement.tpl.html',
            controller: 'WebpageFooterElementModalController',
            backdrop: 'static',
            resolve: {
                footer: function () {
                    return footer;
                }, input: function () {
                    return input;
                }, element: function () {
                    return element;
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.EDITED');
        });
    };
    $scope.removeElement = function (id, index, key) {
        Webpages.removeFooterElement(id, footerId, key)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.DELETED');
                    $state.go($state.current, {}, {reload: true});
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.DELETED');
                }
            });
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.changeOrder = function ($event, key1, key2, moduleKey) {
        const data = $scope.footer.modules[moduleKey].elements;
        $event.stopImmediatePropagation();
        Webpages.changeOrderFooters({
            order_ids: [$scope.footer.modules[moduleKey].elements[key1].order, $scope.footer.modules[moduleKey].elements[key2].order],
            application_id: appId,
            module_key: moduleKey,
            footer_id: footerId
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.footer.modules[moduleKey].elements = data;
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.webpagesFooters', {appId: appId});
    };
}]);

webPagesControllers.controller('WebpageFooterElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'footer', 'input', 'element', 'module', '$locale', '$filter', '$modal', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, footer, input, element, module, $locale, $filter, $modal) {
    'use strict';

    const footerId = $stateParams.footerId;
    $scope.elem = {};

    $scope.errors = {};
    $scope.upload = {};
    $scope.fileUploaded = {};
    $scope.fileName = {};

    if (element.id) {
        $scope.editMode = true;
        $scope.elem = angular.copy(element);
    }

    $scope.footer = angular.copy(footer);
    $scope.inputs = angular.copy(input);
    $scope.moduleKey = angular.copy(module);
    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.tinymceOptions = angular.getTinymceOptions($modal);

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    angular.forEach($scope.inputs, function (val) {
        if (val.type === 'checkbox') {
            if (angular.isDefined($scope.elem[val.key])) {
                if ($scope.elem[val.key] == 'true') {
                    $scope.elem[val.key] = true;
                }
                if ($scope.elem[val.key] == 'false') {
                    $scope.elem[val.key] = false;
                }
            }
        }
        if (val.pattern) {
            val.pattern = new RegExp('^' + val.pattern + '$');
        }
    });

    $scope.pages = [];

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        Webpages.autocompleteFooters(footerId, $scope.moduleKey, text)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $scope.pages = data.elements;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.' + data.error);
                }
            });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        $scope.elem.footer_id = footerId;
        $scope.elem.module_key = $scope.moduleKey;
        Webpages.saveElementFooter($scope.elem, $scope.upload, $scope.editMode)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.element);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.checkValid = function (name) {
        return angular.isDefinedNotNull($scope.errors[name]);
    };

    $scope.removeFile = function (key) {
        delete $scope.upload[key];
        if (angular.isDefined($scope.elem[key])) {
            delete $scope.elem[key];
        }
        $scope.fileUploaded[key] = false;
        $scope.fileName[key] = undefined;
    };

    $scope.uploadSuccess = function (file, key) {
        $scope.upload[key] = file;
        $scope.fileUploaded[key] = true;
        $scope.fileName[key] = undefined;
        $scope.$apply();
    };
}]);

webPagesControllers.controller('WebpageSidebarsElementsController', ['$state', '$scope', '$rootScope', '$stateParams', 'growl', 'Webpages', '$modal', 'Permissions', '$timeout', function ($state, $scope, $rootScope, $stateParams, growl, Webpages, $modal, Permissions, $timeout) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $rootScope.$broadcast('wwwModules', {app: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('cms_www');
    $scope.isDropped = false;

    const appId = $stateParams.application_id;
    const sidebarId = $stateParams.sidebarId;

    const content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");
    $scope.isLoading = true;

    Webpages.getSidebar(appId, sidebarId).then(function (result) {
        let data = result.data;
        $scope.sidebar = data.sidebar;
        $scope.inputs = data.inputs;
    }).finally(function () {
        $scope.isLoading = false;
    });

    $scope.elementCreate = function (sidebar, input, moduleKey) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/sidebarElement.tpl.html',
            controller: 'WebpageSidebarElementModalController',
            backdrop: 'static',
            resolve: {
                sidebar: function () {
                    return sidebar;
                }, input: function () {
                    return input;
                }, element: function () {
                    return {};
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.CREATED');
        });
    };

    $scope.editElement = function (sidebar, input, moduleKey, element) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/web/components/modal/sidebarElement.tpl.html',
            controller: 'WebpageSidebarElementModalController',
            backdrop: 'static',
            resolve: {
                sidebar: function () {
                    return sidebar;
                }, input: function () {
                    return input;
                }, element: function () {
                    return element;
                }, module: function () {
                    return moduleKey;
                }
            }
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
            growl.success('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.SUCCESS.EDITED');
        });
    };
    $scope.removeElement = function (id, index, key) {
        Webpages.removeSidebarElement(id, sidebarId, key).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.APPLICATIONS.MODULES.WWW.PAGES.SUCCESS.ELEMENT.DELETED');
                $state.go($state.current, {}, {reload: true});
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.WWW.PAGES.ERROR.ELEMENT.DELETED');
            }
        });
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.changeOrder = function ($event, key1, key2, moduleKey) {
        const data = $scope.sidebar.modules[moduleKey].elements;
        $event.stopImmediatePropagation();
        Webpages.changeOrderSidebars({
            order_ids: [$scope.sidebar.modules[moduleKey].elements[key1].order, $scope.sidebar.modules[moduleKey].elements[key2].order],
            app_id: appId,
            module_key: moduleKey,
            sidebar_id: sidebarId
        }).then(function (response) {
            if (response.data.success) {
                data = angular.changeOrderResponse(data, key1, key2);
            }
        });
        $scope.sidebar.modules[moduleKey].elements = data;
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.webpagesSidebars', {appId: appId});
    };

    // drag&drop
    $scope.treeOptions = {
        beforeDrag: function () {
            return true;
        }, dropped: function () {
            $scope.isDropped = true;
            $timeout(function () {
                $scope.saveOrder($scope.sidebar.modules);
            }, 1000);
        }
    };

    $scope.saveOrder = function (data) {
        const tmpData = {
            application_id: appId, sidebar_id: sidebarId, modules: data
        };

        Webpages.changeOrderSidebars(tmpData)
            .then(function (result) {
                let data = result.data;
                if (data.success) {
                    // successful changed orders
                }
            })
            .finally(function () {
                $scope.isDropped = false;
            });
    };
}]);

webPagesControllers.controller('WebpageSidebarElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Webpages', 'sidebar', 'input', 'element', 'module', function ($scope, $state, $stateParams, $modalInstance, growl, Webpages, sidebar, input, element, module) {
    'use strict';

    const sidebarId = $stateParams.sidebarId;
    $scope.elem = {};

    $scope.errors = {};
    $scope.upload = {};
    $scope.fileUploaded = {};
    $scope.fileName = {};

    if (element.id) {
        $scope.editMode = true;
        $scope.elem = angular.copy(element);
    }

    $scope.sidebar = angular.copy(sidebar);
    $scope.inputs = angular.copy(input);
    $scope.moduleKey = angular.copy(module);

    angular.forEach($scope.inputs, function (val) {
        if (val.type === 'checkbox') {
            if (angular.isDefined($scope.elem[val.key])) {
                if ($scope.elem[val.key] == 'true') {
                    $scope.elem[val.key] = true;
                }
                if ($scope.elem[val.key] == 'false') {
                    $scope.elem[val.key] = false;
                }
            }
        }
        if (val.pattern) {
            val.pattern = new RegExp('^' + val.pattern + '$');
        }
    });

    $scope.pages = [];
    $scope.autocomplete = function (text) {
        text = text.toLowerCase().trim();
        text = encodeURIComponent(text);

        Webpages.autocompleteSidebars(sidebarId, $scope.moduleKey, text).then(function (result) {
            let data = result.data;
            if (data.success) {
                $scope.pages = data.elements;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.' + data.error);
            }
        });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.elementForm.$valid) {
            $scope.isLoading = true;
            $scope.elem.sidebar_id = sidebarId;
            $scope.elem.module_key = $scope.moduleKey;
            Webpages.saveElementSidebar($scope.elem, $scope.upload, $scope.editMode).then(function (result) {
                let data = result.data;
                if (data.success) {
                    $modalInstance.close(data.element);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        } else {
            growl.error('MODULES.APPLICATIONS.MODULES.WWW.ELEMENTS.ERROR.CREATED');
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.checkValid = function (name) {
        return angular.isDefinedNotNull($scope.errors[name]);
    };

    $scope.removeFile = function (key) {
        delete $scope.upload[key];
        if (angular.isDefined($scope.elem[key])) {
            delete $scope.elem[key];
        }
        $scope.fileUploaded[key] = false;
        $scope.fileName[key] = undefined;
    };

    $scope.uploadSuccess = function (file, key) {
        $scope.upload[key] = file;
        $scope.fileUploaded[key] = true;
        $scope.fileName[key] = undefined;
        $scope.$apply();
    };
}]);

webPagesControllers.controller('WebpageActionsController', ['$scope', '$stateParams', '$window', '$document', 'Webpages', 'growl', function ($scope, $stateParams, $window, $document, Webpages, growl) {
    'use strict';

    $scope.application_id = $stateParams.application_id;

    Webpages.getAllActions($scope.application_id)
        .then(function (result) {
            let data = result.data;
            $scope.types = data.types;
        });

    $scope.generateCSV = function (type, report) {
        const start_date = moment(report.start_date).format('YYYY-MM-DD');
        const end_date = moment(report.end_date).format('YYYY-MM-DD');
        $scope.isLoadingExport = true;
        Webpages.generateCSV($scope.application_id, type, start_date, end_date)
            .then(function (result) {
                let data = result.data;
                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
                // $window.open(data, '_blank');
            }).finally(function () {
            $scope.isLoadingExport = false;
        });
    };

    // DatePickers
    $scope.report = {
        start_date: new Date(), end_date: new Date()
    };

    $scope.popup_start = {
        opened: false
    };

    $scope.popup_end = {
        opened: false
    };

    $scope.format = 'dd-MM-yyyy';

    $scope.dateOptions = {
        dateDisabled: false, formatYear: 'yy', startingDay: 1
    };

    $scope.startDate = function () {
        $scope.popup_start.opened = true;
    };

    $scope.endDate = function () {
        $scope.popup_end.opened = true;
    };

}]);

export default webPagesControllers;
